import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ErrorPage } from "@/components/error-page/ErrorPage";
import { GLOBAL_NAVIGATION_URLS, globalNavigation } from "@/utils/constants";
import { ECashierFlows, EIcon } from "@/utils/enums";

export const WithdrawalNotAvailable = ({
  reason,
}: {
  reason: "no_accounts" | "zero_balance";
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const message =
    reason === "no_accounts"
      ? t("withdrawals.errors.withdrawal_not_available.no_accounts")
      : t("withdrawals.errors.withdrawal_not_available.zero_balance");
  const action = () => {
    if (reason === "no_accounts") {
      globalNavigation(GLOBAL_NAVIGATION_URLS.CREATE_TRADING_ACCOUNT);
    } else {
      navigate(`/${ECashierFlows.Deposit}`);
    }
  };
  const actionLabel =
    reason === "no_accounts"
      ? t("global.nav_buttons.add_trading_account")
      : t("deposit.title");
  return (
    <ErrorPage
      icon={EIcon.EmptyStateError}
      title={t("withdrawals.errors.withdrawal_not_available.title")}
      message={message}
      buttonLabel={actionLabel}
      buttonAction={action}
    />
  );
};
